export const getterTypes = {
    //bet
    BET_COUNTDOWN_LENGTH: 'BET_COUNTDOWN_LENGTH',
    // bet- betType
    BET_BETTYPE_COUNT: 'BET_BETTYPE_COUNT',
    BET_BETTYPE_SUM: 'BET_BETTYPE_SUM',
    // bet- inputBetType
    BET_INPUT_BETTYPE_COUNT: 'BET_INPUT_BETTYPE_COUNT',
    BET_INPUT_BETTYPE_SUM: 'BET_INPUT_BETTYPE_SUM',
    // bet- luzhu
    BET_LUZHU_BETTYPE_COUNT: 'BET_LUZHU_BETTYPE_COUNT',
    BET_LUZHU_BETTYPE_SUM: 'BET_LUZHU_BETTYPE_SUM',
    // bet - cart
    BET_CART_TOTAL_SUM: 'BET_CART_TOTAL_SUM',
    BET_CART_TOTAL_COUNT: 'BET_CART_TOTAL_COUNT',
    // bet - schedule
    BET_SCHEDULE_TOTAL_LENGTH: 'BET_SCHEDULE_TOTAL_ISSUE',
    BET_SCHEDULE_TOTAL_SUM: 'BET_SCHEDULE_TOTAL_SUM',
    BET_SCHEDULE_TARGET_ISSUES: 'BET_SCHEDULE_TARGET_ISSUES',
    // bet - collection
    BET_GET_COLLECTIONS: 'BET_GET_COLLECTIONS',
    // draw history
    DRAW_HISTORY_GAMES: 'DRAW_HISTORY_GAMES',
    DRAW_HISTORY_RECORDS: 'DRAW_HISTORY_RECORDS',
    DRAW_HISTORY_WINNING_NUMBER_FORMATTER_TYPE: 'DRAW_HISTORY_WINNING_NUMBER_FORMATTER_TYPE',
    DRAW_HISTORY_COUNTDOWN_LENGTH: 'DRAW_HISTORY_COUNTDOWN_LENGTH',
    DRAW_HISTORY_CURRENT_ISSUE: 'DRAW_HISTORY_CURRENT_ISSUE',
    DRAW_HISTORY_OLD_ISSUES: 'DRAW_HISTORY_OLD_ISSUES',
    DRAW_HISTORY_COUNT_DOWN: 'DRAW_HISTORY_COUNT_DOWN',
    // lottogame
    BET_LOTTO_GAMES: 'BET_LOTTO_GAMES',
    // predict
    PREDICT_BOARD_CHIPS: 'PREDICT_BOARD_CHIPS',
    PREDICT_ISSUELIMIT: 'PREDICT_ISSUELIMIT',
    PREDICT_BOARDLIMIT: 'PREDICT_BOARDLIMIT',
};

export const mutationTypes = {
    // bet
    BET_UPDATE_GAME_INFO: 'BET_UPDATE_GAME_INFO',
    BET_UPDATE_ISSUE_INFO: 'BET_UPDATE_ISSUE_INFO',
    BET_UPDATE_ISSUE_INTERVAL: 'BET_UPDATE_ISSUE_INTERVAL',
    BET_RECEIVE_WINNING_NUMBER: 'BET_RECEIVE_WINNING_NUMBER',
    BET_ADD_MIAOMIAO_HISTORIES: 'BET_ADD_MIAOMIAO_HISTORIES',
    BET_GET_USER_GAME_INFO: 'BET_GET_USER_GAME_INFO',
    BET_UPDATE_ISSUE_SETTING: 'BET_UPDATE_ISSUE_SETTING',
    BET_SHOW_OLD_ISSUES: 'BET_SHOW_OLD_ISSUES',

    // bet - betType
    BET_BETTYPE_SET_MENU: 'BET_BETTYPE_SET_MENU',
    BET_BETTYPE_SET_MENU_PATH: 'BET_BETTYPE_SET_MENU_PATH',
    BET_BETTYPE_SET_BETTYPE: 'BET_BETTYPE_SET_BETTYPE',
    BET_BETTYPE_SET_MULTIPLE: 'BET_BETTYPE_SET_MULTIPLE',
    BET_BETTYPE_SET_UNIT: 'BET_BETTYPE_SET_UNIT',
    BET_BETTYPE_SET_RETURN_RATE: 'BET_BETTYPE_SET_RETURN_RATE',
    BET_BETTYPE_CALCULATE_COUNT: 'BET_BETTYPE_CALCULATE_COUNT',
    BET_BETTYPE_SELECT_NUMBER: 'BET_BETTYPE_SELECT_NUMBER',
    BET_BETTYPE_CHECK_TEXT_NUMBER: 'BET_BETTYPE_CHECK_TEXT_NUMBER',
    BET_BETTYPE_REVERSE_TEXT_NUMBER: 'BET_BETTYPE_REVERSE_TEXT_NUMBER',
    BET_BETTYPE_CALCULATE_PRIZE: 'BET_BETTYPE_CALCULATE_PRIZE',
    BET_BETTYPE_NORMALIZE_NUMBER: 'BET_BETTYPE_NORMALIZE_NUMBER',
    BET_BETTYPE_COMPRESS_NUMBER: 'BET_BETTYPE_COMPRESS_NUMBER',
    BET_BETTYPE_CLEAR_SELECT: 'BET_BETTYPE_CLEAR_SELECT',
    BET_BETTYPE_TEXT_NUMBER_INPUT: 'BET_BETTYPE_TEXT_NUMBER_INPUT',
    BET_BETTYPE_AUTO_SELECT: 'BET_BETTYPE_AUTO_SELECT',
    BET_BETTYPE_AUTO_SELECT_COLUMN: 'BET_BETTYPE_AUTO_SELECT_COLUMN',
    BET_BETTYPE_SELECT_POSITION: 'BET_BETTYPE_SELECT_POSITION',
    BET_BETTYPE_FASTNUMBER_SELECT: 'BET_BETTYPE_FASTNUMBER_SELECT',
    BET_BETTYPE_UPDATE_HOT_MISS: 'BET_BETTYPE_UPDATE_HOT_MISS',
    BET_BETTYPE_CALCULATE_EARN: 'BET_BETTYPE_CALCULATE_EARN',
    BET_BETTYPE_RANDOM_PICK: 'BET_BETTYPE_RANDOM_PICK',
    BET_BETTYPE_RANDOM_PICK_SPECIFIC: 'BET_BETTYPE_RANDOM_PICK_SPECIFIC',
    // bet - inputBetType
    BET_INPUT_BETTYPE_SET_MENU: 'BET_INPUT_BETTYPE_SET_MENU',
    BET_INPUT_BETTYPE_SET_MENU_PATH: 'BET_INPUT_BETTYPE_SET_MENU_PATH',
    BET_INPUT_BETTYPE_SET_BETTYPE: 'BET_INPUT_BETTYPE_SET_BETTYPE',
    BET_INPUT_BETTYPE_SET_BETTYPE_NAME: 'BET_INPUT_BETTYPE_SET_BETTYPE_NAME',
    BET_INPUT_BETTYPE_SET_UNIT: 'BET_INPUT_BETTYPE_SET_UNIT',
    BET_INPUT_BETTYPE_SET_RETURN_RATE: 'BET_INPUT_BETTYPE_SET_RETURN_RATE',
    BET_INPUT_BETTYPE_CALCULATE_COUNT: 'BET_INPUT_BETTYPE_CALCULATE_COUNT',
    BET_INPUT_BETTYPE_SELECT_NUMBER: 'BET_INPUT_BETTYPE_SELECT_NUMBER',
    BET_INPUT_BETTYPE_CALCULATE_PRIZE: 'BET_INPUT_BETTYPE_CALCULATE_PRIZE',
    BET_INPUT_BETTYPE_CLEAR_SELECT: 'BET_INPUT_BETTYPE_CLEAR_SELECT',
    BET_INPUT_BETTYPE_NUMBER_SELECT: 'BET_INPUT_BETTYPE_NUMBER_SELECT',
    BET_INPUT_BETTYPE_FAST_NUMBER_SELECT: 'BET_INPUT_BETTYPE_FAST_NUMBER_SELECT',
    BET_INPUT_BETTYPE_SET_MULTIPLE: 'BET_INPUT_BETTYPE_SET_MULTIPLE',
    BET_INPUT_BETTYPE_FAST_MODE: 'BET_INPUT_BETTYPE_FAST_MODE',
    BET_INPUT_BETTYPE_FAST_MULTIPLE: 'BET_INPUT_BETTYPE_FAST_MULTIPLE',
    BET_INPUT_BETTYPE_EDIT_NUMBER: 'BET_INPUT_BETTYPE_EDIT_NUMBER',
    //bet - exclude
    BET_EXCLUDE_BETTYPE_SET_BETTYPE: 'BET_EXCLUDE_BETTYPE_SET_BETTYPE',
    BET_EXCLUDE_BETTYPE_CLEAR_SELECT: 'BET_EXCLUDE_BETTYPE_CLEAR_SELECT',
    BET_EXCLUDE_BETTYPE_CLEAR_TEXT_NUMBER: 'BET_EXCLUDE_BETTYPE_CLEAR_TEXT_NUMBER',
    BET_EXCLUDE_BETTYPE_SET_RESULT: 'BET_EXCLUDE_BETTYPE_SET_RESULT',
    BET_EXCLUDE_BETTYPE_NUMBER_SELECT: 'BET_EXCLUDE_BETTYPE_NUMBER_SELECT',
    BET_EXCLUDE_BETTYPE_MULTIPLE: 'BET_EXCLUDE_BETTYPE_MULTIPLE',
    BET_EXCLUDE_BETTYPE_SET_UNIT: 'BET_EXCLUDE_BETTYPE_SET_UNIT',
    BET_EXCLUDE_BETTYPE_SELECT_POSITION: 'BET_EXCLUDE_BETTYPE_SELECT_POSITION',
    BET_EXCLUDE_CREATE_TICKET: 'BET_EXCLUDE_CREATE_TICKET',
    BET_EXCLUDE_BETTYPE_SET_MENU: 'BET_EXCLUDE_BETTYPE_SET_MENU',
    BET_EXCLUDE_BETTYPE_SET_MENU_PATH: 'BET_EXCLUDE_BETTYPE_SET_MENU_PATH',
    BET_EXCLUDE_BETTYPE_CALCULATE_PRIZE: 'BET_EXCLUDE_BETTYPE_CALCULATE_PRIZE',
    BET_EXCLUDE_BETTYPE_TEXT_NUMBER_INPUT: 'BET_EXCLUDE_BETTYPE_TEXT_NUMBER_INPUT',
    BET_EXCLUDE_BETTYPE_CHECK_TEXT_NUMBER: 'BET_EXCLUDE_BETTYPE_CHECK_TEXT_NUMBER',
    BET_EXCLUDE_BETTYPE_REVERSE_TEXT_NUMBER: 'BET_EXCLUDE_BETTYPE_REVERSE_TEXT_NUMBER',
    // bet - luzhu
    BET_LUZHU_BETTYPE_SET_MENU: 'BET_LUZHU_BETTYPE_SET_MENU',
    BET_LUZHU_BETTYPE_SET_MENU_PATH: 'BET_LUZHU_BETTYPE_SET_MENU_PATH',
    BET_LUZHU_BETTYPE_SET_BETTYPE: 'BET_LUZHU_BETTYPE_SET_BETTYPE',
    BET_LUZHU_BETTYPE_SET_MULTIPLE: 'BET_LUZHU_BETTYPE_SET_MULTIPLE',
    BET_LUZHU_BETTYPE_SET_UNIT: 'BET_LUZHU_BETTYPE_SET_UNIT',
    BET_LUZHU_BETTYPE_SET_RETURN_RATE: 'BET_LUZHU_BETTYPE_SET_RETURN_RATE',
    BET_LUZHU_BETTYPE_CALCULATE_COUNT: 'BET_LUZHU_BETTYPE_CALCULATE_COUNT',
    BET_LUZHU_BETTYPE_SELECT_NUMBER: 'BET_LUZHU_BETTYPE_SELECT_NUMBER',
    BET_LUZHU_BETTYPE_CALCULATE_PRIZE: 'BET_LUZHU_BETTYPE_CALCULATE_PRIZE',
    BET_LUZHU_BETTYPE_CLEAR_SELECT: 'BET_LUZHU_BETTYPE_CLEAR_SELECT',
    // bet - cart
    BET_CART_ADD: 'BET_CART_ADD',
    BET_CART_REMOVE: 'BET_CART_REMOVE',
    BET_CART_CLEAR: 'BET_CART_CLEAR',
    BET_CART_SET_MULTIPLE: 'BET_CART_SET_MULTIPLE',
    BET_CART_SET_TICKET_CHECKED: 'BET_CART_SET_TICKET_CHECKED',
    BET_CART_REMOVE_CHECKED_TICKETS: 'BET_CART_REMOVE_CHECKED_TICKETS',
    BET_CART_CHECK_ALL_TICKETS: 'BET_CART_CHECK_ALL_TICKETS',
    BET_CART_UNCHECK_ALL_TICKETS: 'BET_CART_UNCHECK_ALL_TICKETS',
    // bet - schedule
    BET_SCHEDULE_SET_PARAMS: 'BET_SCHEDULE_SET_PARAMS',
    BET_SCHEDULE_SET_ISSUES: 'BET_SCHEDULE_SET_ISSUES',
    BET_SCHEDULE_SET_SPECIFIC_ISSUES_LENGTH: 'BET_SCHEDULE_SET_SPECIFIC_ISSUES_LENGTH',
    BET_SCHEDULE_OPEN: 'BET_SCHEDULE_OPEN',
    BET_SCHEDULE_CLOSE: 'BET_SCHEDULE_CLOSE',
    BET_SCHEDULE_UPDATE_ISSUES: 'BET_SCHEDULE_UPDATE_ISSUES',
    BET_SCHEDULE_UPDATE_SPECIFIC_ISSUES: 'BET_SCHEDULE_UPDATE_SPECIFIC_ISSUES',
    BET_SCHEDULE_CLEAR: 'BET_SCHEDULE_CLEAR',
    BET_SCHEDULE_CHECK: 'BET_SCHEDULE_CHECK',
    BET_SCHEDULE_SET_MULTIPLE: 'BET_SCHEDULE_SET_MULTIPLE',
    BET_SCHEDULE_SET_STOPIFWIN: 'BET_SCHEDULE_SET_STOPIFWIN',
    BET_SCHEDULE_SET_STOP_IF_LOSS: 'BET_SCHEDULE_SET_STOP_IF_LOSS',
    BET_SCHEDULE_SET_STOP_IF_EARN: 'BET_SCHEDULE_SET_STOP_IF_EARN',
    // bet - record
    BET_RECORD_SET: 'BET_RECORD_SET',
    BET_RECORD_ADD: 'BET_RECORD_ADD',
    BET_RECORD_SET_DETAIL: 'BET_RECORD_SET_DETAIL',
    BET_RECORD_CANCEL: 'BET_RECORD_CANCEL',
    // bet - schedule record
    BET_SCHEDULE_RECORD_SET: 'BET_SCHEDULE_RECORD_SET',
    BET_SCHEDULE_RECORD_ADD: 'BET_SCHEDULE_RECORD_ADD',
    BET_SCHEDULE_RECORD_SET_DETAIL: 'BET_SCHEDULE_RECORD_SET_DETAIL',
    BET_SCHEDULE_RECORD_CANCEL: 'BET_SCHEDULE_RECORD_CANCEL',
    // bet - report record
    BET_REPORT_CASHFLOW_SET: 'BET_REPORT_CASHFLOW_SET',
    BET_REPORT_DEPOSIT_SET: 'BET_REPORT_DEPOSIT_SET',
    BET_REPORT_WITHDRAW_SET: 'BET_REPORT_WITHDRAW_SET',
    BET_REPORT_PROFIT_SET: 'BET_REPORT_PROFIT_SET',
    // bet - collection
    BET_SET_COLLECTIONS: 'BET_SET_COLLECTIONS',

    // comboBet
    TOGGLE_DRAGGABLE_COMBO_BET: 'OPEN_DRAGGABLE_COMBO_BET',

    // chat
    CHAT_INIT_DATA: 'CHAT_INIT_DATA',
    CHAT_SET_CONNECTION_STATE: 'CHAT_SET_CONNECTION_STATE',
    CHAT_UPDATE_RECONNECTED_SYNC_TIME: 'CHAT_UPDATE_RECONNECTED_SYNC_TIME',
    CHAT_ADD_ROOM_WINDOW: 'CHAT_ADD_ROOM_WINDOW',
    CHAT_REMOVE_ROOM_WINDOW: 'CHAT_REMOVE_ROOM_WINDOW',
    CHAT_OPEN_ROOM_WINDOW: 'CHAT_OPEN_ROOM_WINDOW',
    CHAT_COLSE_ROOM_WINDOW: 'CHAT_COLSE_ROOM_WINDOW',
    CHAT_ADD_ROOM_MESSAGE_CONTAINER: 'CHAT_ADD_ROOM_MESSAGE_CONTAINER',
    CHAT_REMOVE_ROOM_MESSAGE_CONTAINER: 'CHAT_REMOVE_ROOM_MESSAGE_CONTAINER',
    CHAT_ADD_ROOM_MESSAGE: 'CHAT_ADD_ROOM_MESSAGE',
    CHAT_REMOVE_ROOM_MESSAGE: 'CHAT_REMOVE_ROOM_MESSAGE',
    CHAT_UPDATE_ROOM_MESSAGE_SEND_TIME: 'CHAT_UPDATE_ROOM_MESSAGE_SEND_TIME',
    CHAT_ADD_ROOM_MEMBER: 'CHAT_ADD_ROOM_MEMBER',
    CHAT_REMOVE_ROOM_MEMBER: 'CHAT_REMOVE_ROOM_MEMBER',
    CHAT_ADD_ROOM: 'CHAT_ADD_ROOM',
    CHAT_REMOVE_ROOM: 'CHAT_REMOVE_ROOM',
    CHAT_CHANGE_ROOM_NAME: 'CHAT_CHANGE_ROOM_NAME',
    CHAT_INCREMENT_UNREAD_NUMBER: 'CHAT_INCREMENT_UNREAD_NUMBER',
    CHAT_SET_ROOM_ONLINE_STATE: 'CHAT_SET_ROOM_ONLINE_STATE',
    CHAT_SET_ANONYMITY_STATE: 'CHAT_SET_ANONYMITY_STATE',
    CHAT_REMOVE_ROOM_MESSAGE_BY_CLEAR_TIME: 'CHAT_REMOVE_ROOM_MESSAGE_BY_CLEAR_TIME',
    CHAT_UPDATE_MESSAGE_CLEAR_TIME: 'CHAT_UPDATE_MESSAGE_CLEAR_TIME',
    CHAT_UPDATE_ROOM_ON_TALK_STATE: 'CHAT_UPDATE_ROOM_ON_TALK_STATE',
    CHAT_CHANGE_ROOM_ANNOUNCEMENT: 'CHAT_CHANGE_ROOM_ANNOUNCEMENT',
    CHAT_UPDATE_GROUP_ROOM_READONLY: 'CHAT_UPDATE_GROUP_ROOM_READONLY',
    CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY: 'CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY',
    CHAT_SET_GROUP_ROOM_MEMBER_ROLE: 'CHAT_SET_GROUP_ROOM_MEMBER_ROLE',
    CHAT_UPDATE_LAST_MESSAGE: 'CHAT_UPDATE_LAST_MESSAGE',
    CHAT_SET_CUSTOMER_SERVICE_SESSION_ID: 'CHAT_SET_CUSTOMER_SERVICE_SESSION_ID',
    CHAT_SET_ROOM_WINDOW_SIZE: 'CHAT_SET_ROOM_WINDOW_SIZE',
    CHAT_INFO: 'CHAT_INFO',
    CHAT_SET_MULTICASTING: 'CHAT_SET_MULTICASTING',
    CHAT_UPDATE_DIALOG_PAGE_NAME_AND_DATA: 'CHAT_UPDATE_DIALOG_PAGE_NAME_AND_DATA',
    CHAT_UPDATE_PIN_MESSAGE: 'CHAT_UPDATE_PIN_MESSAGE',
    CHAT_UPDATE_NICKNAME: 'CHAT_UPDATE_NICKNAME',
    CHAT_UPDATE_HEAD_IMAGE: 'CHAT_UPDATE_HEAD_IMAGE',
    // chat - site group
    CHAT_SITE_GROUP_INIT_ROOM: 'CHAT_SITE_GROUP_INIT_ROOM',
    CHAT_SITE_GROUP_UPDATE_ENTER_ROOM_USERNAME: 'CHAT_SITE_GROUP_UPDATE_ENTER_ROOM_USERNAME',
    CHAT_SITE_GROUP_START_TUTOR_TALKING: 'CHAT_SITE_GROUP_START_TUTOR_TALKING',
    CHAT_SITE_GROUP_END_TUTOR_TALKING: 'CHAT_SITE_GROUP_END_TUTOR_TALKING',
    CHAT_SITE_GROUP_UPDATE_TUTOR_MESSAGE_NOTICE_ROOMID: 'CHAT_SITE_GROUP_UPDATE_TUTOR_MESSAGE_NOTICE_ROOMID',
    CHAT_SITE_GROUP_SET_FOLLOW_BET_DATA: 'CHAT_SITE_GROUP_SET_FOLLOW_BET_DATA',
    CHAT_SITE_GROUP_UPDATE_MEMBER_READONLY: 'CHAT_SITE_GROUP_UPDATE_MEMBER_READONLY',
    CHAT_SITE_GROUP_SET_PIN_MESSAGE: 'CHAT_SITE_GROUP_SET_PIN_MESSAGE',
    // issue statistic
    ISSUE_STATISTIC_UPDATE_ISSUE_STATISTIC: 'ISSUE_STATISTIC_UPDATE_ISSUE_STATISTIC',
    ISSUE_STATISTIC_INIT_COMBO_COUNT: 'ISSUE_STATISTIC_INIT_COMBO_COUNT',
    ISSUE_STATISTIC_INIT_MISS_CATEGORY: 'ISSUE_STATISTIC_INIT_MISS_CATEGORY',
    ISSUE_STATISTIC_SET_COMBO_COUNT: 'ISSUE_STATISTIC_SET_COMBO_COUNT',
    ISSUE_STATISTIC_SET_MISS_CATEGORY: 'ISSUE_STATISTIC_SET_MISS_CATEGORY',
    ISSUE_STATISTIC_SET_COMBO_CATEGORY: 'ISSUE_STATISTIC_SET_COMBO_CATEGORY',
    // draw history
    DRAW_HISTORY_UPDATE_RECORDS: 'DRAW_HISTORY_UPDATE_RECORDS',
    DRAW_HISTORY_INSERT_RECORDS: 'DRAW_HISTORY_INSERT_RECORDS',
    DRAW_HISTORY_CLEAN_RECORDS: 'DRAW_HISTORY_CLEAN_RECORDS',
    DRAW_HISTORY_UPDATE_GAMES: 'DRAW_HISTORY_UPDATE_GAMES',
    DRAW_HISTORY_UPDATE_MISSES: 'DRAW_HISTORY_UPDATE_MISSES',
    DRAW_HISTORY_UPDATE_ISSUE_INFO: 'DRAW_HISTORY_UPDATE_ISSUE_INFO',
    DRAW_HISTORY_UPDATE_ISSUE_INTERVAL: 'DRAW_HISTORY_UPDATE_ISSUE_INTERVAL',
    DRAW_HISTORY_RECEIVE_WINNING_NUMBER: 'DRAW_HISTORY_RECEIVE_WINNING_NUMBER',
    DRAW_HISTORY_SET_GAME_ID: 'DRAW_HISTORY_SET_GAME_ID',
    DRAW_HISTORY_UPDATE_ISSUE_SETTING: 'DRAW_HISTORY_UPDATE_ISSUE_SETTING',
    // user Info
    USER_INFO_INIT: 'USER_INFO_INIT',
    USER_INFO_NICK_NAME: 'USER_INFO_NICK_NAME',
    USER_INFO_HEAD_IMAGE: 'USER_INFO_HEAD_IMAGE',
    USER_INFO_REGISTER_LINK_CODE: 'USER_INFO_REGISTER_LINK_CODE',
    USER_INFO_PRIVILEGES: 'USER_INFO_PRIVILEGES',
    USER_INFO_PRIVILEGES_BONUS: 'USER_INFO_PRIVILEGES_BONUS',
    USER_INFO_WALLET_AMOUNT: 'USER_INFO_WALLET_AMOUNT',
    USER_INFO_MERCHANT_CODE: 'USER_INFO_MERCHANT_CODE',
    USER_INFO_HIDE_WALLET_AMOUNT: 'USER_INFO_HIDE_WALLET_AMOUNT',
    USER_INFO_AUDIO_MUTED: 'USER_INFO_AUDIO_MUTED',
    USER_INFO_HIDE_AWARD_NOTIFY: 'USER_INFO_HIDE_AWARD_NOTIFY',
    USER_INFO_SHOW_ANIMAL_NUMBER: 'USER_INFO_SHOW_ANIMAL_NUMBER',
    USER_INFO_DEMO_LINK: 'USER_INFO_DEMO_LINK', //試玩連結
    AFK_CONFIG: 'AFK_CONFIG', //下載中心資料
    USER_INFO_DEMO_SITE: 'USER_INFO_DEMO_SITE', //DEMO站
    USER_INFO_SKIN_COLOR: 'USER_INFO_SKIN_COLOR',
    USER_INFO_IS_WECHAT_ENABLED: 'USER_INFO_IS_WECHAT_ENABLED',
    USER_INFO_GET_BASE_DATA: 'USER_INFO_GET_BASE_DATA',
    USER_INFO_ALERTS: 'USER_INFO_ALERTS', //玩家個人提示訊息
    USER_INFO_GREETINGS: 'USER_INFO_GREETINGS', //玩家問候語
    USER_INFO_INITIALIZED: 'USER_INFO_INITIALIZED',
    USER_INFO_TELEGRAM_BOT: 'USER_INFO_TELEGRAM_BOT',
    USER_INFO_TELEGRAM_USER: 'USER_INFO_TELEGRAM_USER',

    //VIP
    VIP_INFO: 'VIP_INFO',

    // activity
    ACTIVITY_INFO: 'ACTIVITY_INFO',

    UNREAD_ANNOUNCEMENT: 'UNREAD_ANNOUNCEMENT',
    UNREAD_ACTIVITY_COUNT: 'UNREAD_ACTIVITY_COUNT',
    AGENTACTIVITY_NOTICE_TEAMACTIVITY_UNREAD_COUNT: 'AGENTACTIVITY_NOTICE_TEAMACTIVITY_UNREAD_COUNT',
    AGENTACTIVITY_NOTICE_TEAMREDPACKRAIN_COUNT: 'AGENTACTIVITY_NOTICE_TEAMREDPACKRAIN_COUNT',
    // Account Security Scroe
    SECURITY_SCORE: 'SECURITY_SCORE',
    //首頁顯示下載APP入口
    DOWNLOAD_SHORTCUT: 'DOWNLOAD_SHORTCUT',
    SET_LOTTOGAME_DATA: 'SET_LOTTOGAME_DATA',

    SPEED_TEST_CONFIG: 'SPEED_TEST_CONFIG',
    SPEED_TEST_URL_LIST: 'SPEED_TEST_URL_LIST',

    IS_ENABLE_CHECKIP: 'IS_ENABLE_CHECKIP',
    IS_ENABLE_GOOGLEAUTHENTICATOR: 'IS_ENABLE_GOOGLEAUTHENTICATOR',
    EMAIL: 'EMAIL',
    HAVE_AUTH_QUESTION: 'HAVE_AUTH_QUESTION',

    AFK_URL_SET: 'AFK_URL_SET',

    ANNOUNCEMENTS: 'ANNOUNCEMENTS',
    SELECTED_ANNOUNCEMENT_ID: 'SELECTED_ANNOUNCEMENT_ID',
    IS_LOGIN_WITH_GOOGLEAUTH: 'IS_LOGIN_WITH_GOOGLEAUTH',

    // predict
    PREDICT_SET_CONFIG: 'PREDICT_SET_CONFIG',
    PREDICT_ADD_BOARD_CHIPS: 'PREDICT_ADD_BOARD_CHIPS',
    PREDICT_UPDATE_BOARD_CHIPS: 'PREDICT_UPDATE_BOARD_CHIPS',
    PREDICT_SAVE_BOARD_CHIPS: 'PREDICT_SAVE_BOARD_CHIPS',
    PREDICT_SET_GAMEID: 'PREDICT_SET_GAMEID',
    PREDICT_SET_BOARDID: 'PREDICT_SET_BOARDID',
    PREDICT_ADD_GAMELIMIT: 'PREDICT_ADD_GAMELIMIT',
    PREDICT_UPDATE_GAMELIMIT: 'PREDICT_UPDATE_GAMELIMIT',
    PREDICT_SAVE_GAMELIMIT: 'PREDICT_SAVE_GAMELIMIT',
};

export const actionTypes = {
    // bet
    BET_INIT: 'BET_INIT',
    BET_GET_GAME_INFO: 'BET_GET_GAME_INFO',
    BET_GET_ISSUE_INFO: 'BET_GET_ISSUE_INFO',
    BET_UPDATE_ISSUE_INTERVAL: 'BET_UPDATE_ISSUE_INTERVAL',
    BET_RECEIVE_WINNING_NUMBER: 'BET_RECEIVE_WINNING_NUMBER',
    BET_CONFIRM: 'BET_CONFIRM',
    BET_SCHEDULE: 'BET_SCHEDULE',
    BET_FOLLOW_CONFIRM: 'BET_FOLLOW_CONFIRM',
    // bet- betType
    BET_BETTYPE_SET_CATEGORY: 'BET_BETTYPE_SET_CATEGORY',
    BET_BETTYPE_SET_BETTYPE: 'BET_BETTYPE_SET_BETTYPE',
    BET_BETTYPE_SET_MULTIPLE: 'BET_BETTYPE_SET_MULTIPLE',
    BET_BETTYPE_SET_UNIT: 'BET_BETTYPE_SET_UNIT',
    BET_BETTYPE_SET_RETURN_RATE: 'BET_BETTYPE_SET_RETURN_RATE',
    BET_BETTYPE_CALCULATE_PRIZE: 'BET_BETTYPE_CALCULATE_PRIZE',
    BET_BETTYPE_NUMBER_SELECT: 'BET_BETTYPE_NUMBER_SELECT',
    BET_BETTYPE_TEXT_NUMBER_INPUT: 'BET_BETTYPE_TEXT_NUMBER_INPUT',
    BET_BETTYPE_TEXT_NUMBER_REVERSE: 'BET_BETTYPE_TEXT_NUMBER_REVERSE',
    BET_BETTYPE_TEXT_NUMBER_UPLOAD: 'BET_BETTYPE_TEXT_NUMBER_UPLOAD',
    BET_BETTYPE_REMOVE_DUPLICATE: 'BET_BETTYPE_REMOVE_DUPLICATE',
    BET_BETTYPE_AUTO_SELECT: 'BET_BETTYPE_AUTO_SELECT',
    BET_BETTYPE_AUTO_SELECT_COLUMN: 'BET_BETTYPE_AUTO_SELECT_COLUMN',
    BET_BETTYPE_CREATE_TICKET: 'BET_BETTYPE_CREATE_TICKET',
    BET_BETTYPE_FASTNUMBER_SELECT: 'BET_BETTYPE_FASTNUMBER_SELECT',
    BET_BETTYPE_UPDATE_HOT_MISS: 'BET_BETTYPE_UPDATE_HOT_MISS',
    BET_BETTYPE_CALCULATE_EARN: 'BET_BETTYPE_CALCULATE_EARN',
    BET_BETTYPE_SET_DECREASEODDS: 'BET_BETTYPE_SET_DECREASEODDS',
    // bet- inputBetType
    BET_INPUT_BETTYPE_SET_CATEGORY: 'BET_INPUT_BETTYPE_SET_CATEGORY',
    BET_INPUT_BETTYPE_SET_BETTYPE: 'BET_INPUT_BETTYPE_SET_BETTYPE',
    BET_INPUT_BETTYPE_SET_MULTIPLE: 'BET_INPUT_BETTYPE_SET_MULTIPLE',
    BET_INPUT_BETTYPE_CALCULATE_PRIZE: 'BET_INPUT_BETTYPE_CALCULATE_PRIZE',
    BET_INPUT_BETTYPE_SET_UNIT: 'BET_INPUT_BETTYPE_SET_UNIT',
    BET_INPUT_BETTYPE_SET_RETURN_RATE: 'BET_INPUT_BETTYPE_SET_RETURN_RATE',
    BET_INPUT_BETTYPE_NUMBER_SELECT: 'BET_INPUT_BETTYPE_NUMBER_SELECT',
    BET_INPUT_BETTYPE_FAST_NUMBER_SELECT: 'BET_INPUT_BETTYPE_FAST_NUMBER_SELECT',
    BET_INPUT_BETTYPE_CREATE_TICKET: 'BET_INPUT_BETTYPE_CREATE_TICKET',
    BET_INPUT_BETTYPE_FAST_MULTIPLE: 'BET_INPUT_BETTYPE_FAST_MULTIPLE',
    BET_INPUT_BETTYPE_SET_DECREASEODDS: 'BET_INPUT_BETTYPE_SET_DECREASEODDS',
    //bet-exclude
    BET_EXCLUDE_BETTYPE_SET_BETTYPE: 'BET_EXCLUDE_BETTYPE_SET_BETTYPE',
    BET_EXCLUDE_BETTYPE_NUMBER_SELECT: 'BET_EXCLUDE_BETTYPE_NUMBER_SELECT',
    BET_EXCLUDE_BETTYPE_SET_UNIT: 'BET_EXCLUDE_BETTYPE_SET_UNIT',
    BET_EXCLUDE_BETTYPE_SELECT_POSITION: 'BET_EXCLUDE_BETTYPE_SELECT_POSITION',
    BET_EXCLUDE_CREATE_TICKET: 'BET_EXCLUDE_CREATE_TICKET',
    BET_EXCLUDE_BETTYPE_SET_CATEGORY: 'BET_EXCLUDE_BETTYPE_SET_CATEGORY',
    BET_EXCLUDE_BETTYPE_CALCULATE_PRIZE: 'BET_EXCLUDE_BETTYPE_CALCULATE_PRIZE',
    BET_EXCLUDE_BETTYPE_TEXT_NUMBER_UPLOAD: 'BET_EXCLUDE_BETTYPE_TEXT_NUMBER_UPLOAD',
    BET_EXCLUDE_BETTYPE_TEXT_NUMBER_REVERSE: 'BET_EXCLUDE_BETTYPE_TEXT_NUMBER_REVERSE',
    BET_EXCLUDE_BETTYPE_REMOVE_DUPLICATE : 'BET_EXCLUDE_BETTYPE_REMOVE_DUPLICATE',
    BET_EXCLUDE_BETTYPE_TEXT_NUMBER_INPUT: 'BET_EXCLUDE_BETTYPE_TEXT_NUMBER_INPUT',
    BET_EXCLUDE_BETTYPE_CHECK_TEXT_NUMBER: 'BET_EXCLUDE_BETTYPE_CHECK_TEXT_NUMBER',
    
    //bet- luzhu
    BET_LUZHU_BETTYPE_SET_CATEGORY: 'BET_LUZHU_BETTYPE_SET_CATEGORY',
    BET_LUZHU_BETTYPE_SET_BETTYPE: 'BET_LUZHU_BETTYPE_SET_BETTYPE',
    BET_LUZHU_BETTYPE_SET_MULTIPLE: 'BET_LUZHU_BETTYPE_SET_MULTIPLE',
    BET_LUZHU_BETTYPE_CALCULATE_PRIZE: 'BET_LUZHU_BETTYPE_CALCULATE_PRIZE',
    BET_LUZHU_BETTYPE_SET_UNIT: 'BET_LUZHU_BETTYPE_SET_UNIT',
    BET_LUZHU_BETTYPE_SET_RETURN_RATE: 'BET_LUZHU_BETTYPE_SET_RETURN_RATE',
    BET_LUZHU_BETTYPE_NUMBER_SELECT: 'BET_LUZHU_BETTYPE_NUMBER_SELECT',
    BET_LUZHU_BETTYPE_CREATE_TICKET: 'BET_LUZHU_BETTYPE_CREATE_TICKET',
    // bet - schedule
    BET_SCHEDULE_TOGGLE: 'BET_SCHEDULE_TOGGLE',
    BET_SCHEDULE_GENERATE_SAME: 'BET_SCHEDULE_GENERATE_SAME',
    BET_SCHEDULE_GENERATE_DOUBLE: 'BET_SCHEDULE_GENERATE_DOUBLE',
    BET_SCHEDULE_GENERATE_PROFIT: 'BET_SCHEDULE_GENERATE_PROFIT',
    BET_SCHEDULE_SET_SPECIFIC_ISSUES_LENGTH: 'BET_SCHEDULE_SET_SPECIFIC_ISSUES_LENGTH',
    BET_SCHEDULE_UPDATE_ISSUES: 'BET_SCHEDULE_UPDATE_ISSUES',
    BET_SCHEDULE_UPDATE_SPECIFIC_ISSUES: 'BET_SCHEDULE_UPDATE_SPECIFIC_ISSUES',
    // bet - record
    BET_RECORD_GET: 'BET_RECORD_GET',
    BET_RECORD_CACHE_GET: 'BET_RECORD_CACHE_GET',
    BET_RECORD_GET_DETAIL: 'BET_RECORD_GET_DETAIL',
    BET_RECORD_CANCEL: 'BET_RECORD_CANCEL',
    BET_RECORD_CANCELALL: 'BET_RECORD_CANCELALL',
    // bet - schedule record
    BET_SCHEDULE_RECORD_GET: 'BET_SCHEDULE_RECORD_GET',
    BET_SCHEDULE_RECORD_GET_DETAIL: 'BET_SCHEDULE_RECORD_GET_DETAIL',
    BET_SCHEDULE_RECORD_CANCEL: 'BET_SCHEDULE_RECORD_CANCEL',
    // bet - report record
    BET_REPORT_CASHFLOW_GET: 'BET_REPORT_CASHFLOW_GET',
    BET_REPORT_DEPOSIT_GET: 'BET_REPORT_DEPOSIT_GET',
    BET_REPORT_WITHDRAW_GET: 'BET_REPORT_WITHDRAW_GET',
    BET_REPORT_PROFIT_GET: 'BET_REPORT_PROFIT_GET',
    // bet - collection
    BET_GET_COLLECTIONS: 'BET_GET_COLLECTIONS',
    BET_SET_COLLECTIONS: 'BET_SET_COLLECTIONS',
    // chat
    CHAT_OPEN_ROOM_WINDOW: 'CHAT_OPEN_ROOM_WINDOW',
    CHAT_CLOSE_ROOM_WINDOW: 'CHAT_CLOSE_ROOM_WINDOW',
    CHAT_REMOVE_ROOM_WINDOW: 'CHAT_REMOVE_ROOM_WINDOW',
    CHAT_RELOAD_HISTORY_MESSAGE: 'CHAT_RELOAD_HISTORY_MESSAGE',
    CHAT_SEND_MESSAGE: 'CHAT_SEND_MESSAGE',
    CHAT_SEND_MESSAGE_MULTICAST: 'CHAT_SEND_MESSAGE_MULTICAST',
    CHAT_RECEIVE_MESSAGE: 'CHAT_RECEIVE_MESSAGE',
    CHAT_UPLOAD_IMAGE: 'CHAT_UPLOAD_IMAGE',
    CHAT_ADD_CUSTOMER_SERVICE_WAITING: 'CHAT_ADD_CUSTOMER_SERVICE_WAITING',
    CHAT_START_CUSTOMER_SERVICE_SERVING: 'CHAT_START_CUSTOMER_SERVICE_SERVING',
    CHAT_FINISH_CUSTOMER_SERVICE_SERVING: 'CHAT_FINISH_CUSTOMER_SERVICE_SERVING',
    CHAT_SET_HISTORY_MESSAGE_CLEAR_TIME: 'CHAT_SET_HISTORY_MESSAGE_CLEAR_TIME',
    CHAT_RECEIVE_HISTORY_MESSAGE_CLEAR_TIME: 'CHAT_RECEIVE_HISTORY_MESSAGE_CLEAR_TIME',
    CHAT_ADD_GROUP_ROOM: 'CHAT_ADD_GROUP_ROOM',
    CHAT_REMOVE_GROUP_ROOM: 'CHAT_REMOVE_GROUP_ROOM',
    CHAT_SET_GROUP_ROOM_NAME: 'CHAT_SET_GROUP_ROOM_NAME',
    CHAT_ADD_GROUP_ROOM_MEMBER: 'CHAT_ADD_GROUP_ROOM_MEMBER',
    CHAT_REMOVE_GROUP_ROOM_MEMBER: 'CHAT_REMOVE_GROUP_ROOM_MEMBER',
    CHAT_UPDATE_GROUP_ROOM_READONLY: 'CHAT_UPDATE_GROUP_ROOM_READONLY',
    CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY: 'CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY',
    CHAT_SET_GROUP_ROOM_ANNOUNCEMENT: 'CHAT_SET_GROUP_ROOM_ANNOUNCEMENT',
    CHAT_ADD_JSON_GROUP_ROOM_ANNOUNCEMENT: 'CHAT_ADD_JSON_GROUP_ROOM_ANNOUNCEMENT',
    CHAT_REMOVE_JSON_GROUP_ROOM_ANNOUNCEMENT: 'CHAT_REMOVE_JSON_GROUP_ROOM_ANNOUNCEMENT',
    CHAT_SET_GROUP_ROOM_MEMBER_ROLE: 'CHAT_SET_GROUP_ROOM_MEMBER_ROLE',
    CHAT_SIGNALR_STATE_CHANGED: 'CHAT_SIGNALR_STATE_CHANGED',
    CHAT_CUSTOMER_SERVICE_RATING: 'CHAT_CUSTOMER_SERVICE_RATING',
    CHAT_UPDATE_MOBILE_DIALOG_NAME_AND_DATA: 'CHAT_UPDATE_MOBILE_DIALOG_NAME_AND_DATA',
    CHAT_CHECK_UPLOAD_IMAGE_LIMIT: 'CHAT_CHECK_UPLOAD_IMAGE_LIMIT',
    // chat - anonymity
    CHAT_ANONYMITY_INIT: 'CHAT_ANONYMITY_INIT',
    CHAT_ANONYMITY_SEND_MESSAGE: 'CHAT_ANONYMITY_SEND_MESSAGE',
    // chat - site group
    CHAT_SITE_GROUP_ENTER_ROOM: 'CHAT_SITE_GROUP_ENTER_ROOM',
    CHAT_SITE_GROUP_LEAVE_ROOM: 'CHAT_SITE_GROUP_LEAVE_ROOM',
    CHAT_SITE_GROUP_UPDATE_ROOMS: 'CHAT_SITE_GROUP_UPDATE_ROOMS',
    CHAT_SITE_GROUP_ADD_TUTOR_ROOM: 'CHAT_SITE_GROUP_ADD_TUTOR_ROOM',
    CHAT_SITE_GROUP_REMOVE_MESSAGE: 'CHAT_SITE_GROUP_REMOVE_MESSAGE',
    CHAT_SITE_GROUP_GET_MESSAGE_USER_INFO: 'CHAT_SITE_GROUP_GET_MESSAGE_USER_INFO',
    CHAT_SITE_GROUP_UPDATE_MEMBER_READONLY: 'CHAT_SITE_GROUP_UPDATE_MEMBER_READONLY',
    CHAT_SITE_GROUP_CLEAR_MESSAGE: 'CHAT_SITE_GROUP_CLEAR_MESSAGE',
    CHAT_SITE_GROUP_SET_PIN_MESSAGE: 'CHAT_SITE_GROUP_SET_PIN_MESSAGE',
    CHAT_SITE_GROUP_SEARCH_MEMBER: 'CHAT_SITE_GROUP_SEARCH_MEMBER',
    CHAT_SITE_GROUP_REMOVE_TUTOR_RECENT_ROOM: 'CHAT_SITE_GROUP_REMOVE_TUTOR_RECENT_ROOM',
    CHAT_SITE_GROUP_GET_ROOM_MEMBER_LIST: 'CHAT_SITE_GROUP_GET_ROOM_MEMBER_LIST',
    CHAT_SITE_GROUP_CHECK_TUTOR_MESSAGE_LIST_ROOM: 'CHAT_SITE_GROUP_CHECK_TUTOR_MESSAGE_LIST_ROOM',
    // issue statistic
    ISSUE_STATISTIC_UPDATE_ISSUE_STATISTIC: 'ISSUE_STATISTIC_UPDATE_ISSUE_STATISTIC',
    // draw history
    DRAW_HISTORY_GET_TREND: 'DRAW_HISTORY_GET_TREND',
    DRAW_HISTORY_GET_GAMES: 'DRAW_HISTORY_GET_GAMES',
    DRAW_HISTORY_UPDATE_ISSUE_INTERVAL: 'DRAW_HISTORY_UPDATE_ISSUE_INTERVAL',
    DRAW_HISTORY_GET_ISSUE_INFO: 'DRAW_HISTORY_GET_ISSUE_INFO',
    DRAW_HISTORY_RECEIVE_WINNING_NUMBER: 'DRAW_HISTORY_RECEIVE_WINNING_NUMBER',
    // user Info
    USER_INFO_INIT: 'USER_INFO_INIT',
    USER_INFO_NICK_NAME: 'USER_INFO_NICK_NAME',
    USER_INFO_HEAD_IMAGE: 'USER_INFO_HEAD_IMAGE',
    USER_INFO_REGISTER_LINK_CODE: 'USER_INFO_REGISTER_LINK_CODE',
    USER_INFO_PRIVILEGES: 'USER_INFO_PRIVILEGES',
    USER_INFO_PRIVILEGES_BONUS: 'USER_INFO_PRIVILEGES_BONUS',
    USER_INFO_WALLET_AMOUNT: 'USER_INFO_WALLET_AMOUNT',
    USER_INFO_RECYCLE_ALL: 'USER_INFO_RECYCLE_ALL',
    USER_INFO_MERCHANT_CODE: 'USER_INFO_MERCHANT_CODE',
    USER_INFO_HIDE_WALLET_AMOUNT: 'USER_INFO_HIDE_WALLET_AMOUNT',
    USER_INFO_AUDIO_MUTED: 'USER_INFO_AUDIO_MUTED',
    USER_INFO_HIDE_AWARD_NOTIFY: 'USER_INFO_HIDE_AWARD_NOTIFY',
    USER_INFO_DEMO_LINK: 'USER_INFO_DEMO_LINK',
    AFK_CONFIG: 'AFK_CONFIG', //下載中心資料
    USER_INFO_DEMO_SITE: 'USER_INFO_DEMO_SITE',
    USER_INFO_SKIN_COLOR: 'USER_INFO_SKIN_COLOR',
    USER_INFO_IS_WECHAT_ENABLED: 'USER_INFO_IS_WECHAT_ENABLED',
    USER_INFO_GET_BASE_DATA: 'USER_INFO_GET_BASE_DATA',
    USER_INFO_ALERTS: 'USER_INFO_ALERTS',
    USER_INFO_GREETINGS: 'USER_INFO_GREETINGS',
    USER_INFO_TELEGRAM_BOT: 'USER_INFO_TELEGRAM_BOT',
    USER_INFO_TELEGRAM_USER: 'USER_INFO_TELEGRAM_USER',

    //VIP
    VIP_INFO: 'VIP_INFO',

    // Announcement
    UNREAD_ANNOUNCEMENT: 'UNREAD_ANNOUNCEMENT',
    // Activity
    UNREAD_ACTIVITY_COUNT: 'UNREAD_ACTIVITY_COUNT',
    // AgentActivity
    AGENTACTIVITY_NOTICE_TEAMACTIVITY_UNREAD_COUNT: 'AGENTACTIVITY_NOTICE_TEAMACTIVITY_UNREAD_COUNT',
    AGENTACTIVITY_NOTICE_TEAMREDPACKRAIN_COUNT: 'AGENTACTIVITY_NOTICE_TEAMREDPACKRAIN_COUNT',
    // Account Security Scroe
    SECURITY_SCORE: 'SECURITY_SCORE',

    CHAT_SYSTEM_MESSAGE: 'CHAT_SYSTEM_MESSAGE',
    CHAT_INFO: 'CHAT_INFO',

    LOTTOGAME_DATA: 'LOTTOGAME_DATA',

    //首頁顯示下載APP入口
    DOWNLOAD_SHORTCUT: 'DOWNLOAD_SHORTCUT',
    //測速配置
    SPEED_TEST_CONFIG: 'SPEED_TEST_CONFIG',
    SPEED_TEST_URL_LIST: 'SPEED_TEST_URL_LIST',

    IS_ENABLE_CHECKIP: 'IS_ENABLE_CHECKIP',
    IS_ENABLE_GOOGLEAUTHENTICATOR: 'IS_ENABLE_GOOGLEAUTHENTICATOR',
    EMAIL: 'EMAIL',
    HAVE_AUTH_QUESTION: 'HAVE_AUTH_QUESTION',

    AFK_URL_SET: 'AFK_URL_SET',

    ANNOUNCEMENTS: 'ANNOUNCEMENTS',
    SELECTED_ANNOUNCEMENT_ID: 'SELECTED_ANNOUNCEMENT_ID',
    IS_LOGIN_WITH_GOOGLEAUTH: 'IS_LOGIN_WITH_GOOGLEAUTH',

    // predict
    PREDICT_GET_CONFIG: 'PREDICT_GET_CONFIG',
    PREDICT_CHECK_LIMIT: 'PREDICT_CHECK_LIMIT',
    PREDICT_CHECK_ISSUELIMIT: 'PREDICT_CHECK_ISSUELIMIT',
    PREDICT_CHECK_BOARDLIMIT: 'PREDICT_CHECK_BOARDLIMIT',
    PREDICT_SET_LIMIT: 'PREDICT_SET_LIMIT',
};
